/**
 * Post.content() can return either a JSON string or an already-decoded object
 * depending on the API serializer path. Normalizes both cases to a typed object.
 */
export default function parsePostContent(raw) {
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw ?? null;
}
flarum.reg.add('forumaker-arena', 'common/helpers/parsePostContent', parsePostContent);